"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loggerCreate = exports.logger = void 0;
require("core-js/modules/es.array.concat.js");
var standardOutput = console;
var loggerCreate = function loggerCreate() {
  var impl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : standardOutput;
  return {
    log: impl.log,
    debug: impl.debug,
    warn: impl.warn,
    deprecateValue: function deprecateValue(componentName, propName, oldValue, useInstead, msg) {
      return impl.log("'".concat(componentName, ".").concat(propName, "' '").concat(oldValue, "' has been deprecated."), "Use '".concat(useInstead, "' instead."), msg || '');
    },
    deprecateProp: function deprecateProp(componentName, oldProp, useInstead, msg) {
      return impl.log("'".concat(componentName, ".").concat(oldProp, "' has been deprecated."), "Use '".concat(useInstead, "' instead."), msg || '');
    },
    error: impl.error,
    fail: function fail(message) {
      throw new Error(message);
    },
    setGlobalImplementation: function setGlobalImplementation() {
      standardOutput = impl;
    }
  };
};
exports.loggerCreate = loggerCreate;
var logger = loggerCreate();
exports.logger = logger;